import { Trigger } from '@radix-ui/react-popover';
import { approvalStatusQualityMapper } from 'modules/campaigns/lib/constants';
import { findCountryCode } from 'modules/templateEditor/common/LocaleLabel/LocaleLabel';
import { WhatsAppLocaleContent } from 'modules/templateEditor/common/types';
import { useState } from 'react';
import { FlagIcon } from 'ui/flags/FlagIcon';
import { Popover, PopoverContent, PopoverPlacements } from 'ui/popover';
import {
  DashedSpan,
  FlagSpan,
  PopoverSpan,
  StyledContainer,
  StyledItem,
  StyledList,
} from './LocalesPopover.styles';

type LocalesPopoverProps = {
  whatsAppLocaleContent: WhatsAppLocaleContent[];
};

const LocaleFlag = ({ tag, languageName }: { tag: string; languageName: JSX.Element }) => {
  return (
    <FlagSpan>
      <FlagIcon code={findCountryCode(tag)} /> {languageName}
    </FlagSpan>
  );
};

export const LocalesPopover = ({ whatsAppLocaleContent }: LocalesPopoverProps) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <StyledContainer
      onMouseEnter={() => setIsPopoverOpen(true)}
      onMouseLeave={() => setIsPopoverOpen(false)}
    >
      <Popover open={isPopoverOpen}>
        <PopoverContent onOpenAutoFocus={(e) => e.preventDefault()} side={PopoverPlacements.Top}>
          <StyledList>
            {whatsAppLocaleContent.map(
              ({ languageName, locale, metaApprovalStatus, qualityRating }) => (
                <StyledItem key={locale}>
                  <LocaleFlag
                    tag={locale || ''}
                    languageName={<PopoverSpan>{languageName || locale}</PopoverSpan>}
                  />
                  {metaApprovalStatus &&
                    approvalStatusQualityMapper(metaApprovalStatus, qualityRating)}
                </StyledItem>
              ),
            )}
          </StyledList>
        </PopoverContent>
        <Trigger asChild>
          {whatsAppLocaleContent.length > 1 ? (
            <DashedSpan>{whatsAppLocaleContent.length} locales</DashedSpan>
          ) : (
            <span>
              <LocaleFlag
                tag={whatsAppLocaleContent[0].locale || ''}
                languageName={
                  <DashedSpan>
                    {whatsAppLocaleContent[0].languageName || whatsAppLocaleContent[0].locale}
                  </DashedSpan>
                }
              />
            </span>
          )}
        </Trigger>
      </Popover>
    </StyledContainer>
  );
};
